<template>
  <div class="succeed">
    <p>申请退货</p>
    <div class="succeedContent">
      <div class="succeedcontent-content">
        <p><i class="el-icon-success" style="font-size: 60px; color: #7ed321"></i></p>
        <p><b style="font-size: 16px">售后申请提交成功</b></p>
        <p style="color: #ccc">售后专员可能与您电话沟通,请保持手机畅通</p>
        <p><button style="width: 100px; height: 35px; background: #000; color: #fff" @click="back">返回</button></p>
      </div>
    </div>
    <div class="goods-bottom">
      <p><i class="el-icon-warning" style="color:#F7A500"></i>温馨提示:</p>
      <p>*商品寄回地址将在审核通过之后以短信形式告知</p>
      <p>*商品寄回地址将在审核通过之后以短信形式告知</p>
      <p>*商品寄回地址将在审核通过之后以短信形式告知</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.succeed {
  width: 100%;
  height: 100%;
  .succeedContent {
    position: relative;
    width: 100%;
    height: 70%;
    background: #fff;
    margin-top: 5px;
    .succeedcontent-content {
      width: 100%;
      position: absolute;
      top: 30%;
      height: 180px;
      line-height: 3.5em;
      text-align: center;
      p:nth-child(2) {
        line-height: 2em;
      }
      p:nth-child(3) {
        line-height: 2em;
      }
      p:nth-child(4) {
        line-height: 10em;
      }
    }
  }
  .goods-bottom {
    width: 100%;
    height: 100px;
    border: 1px solid #F7A500;
    margin-top: 20px;
    line-height: 2em;
    background: #1AF7A500;
    p{
      margin-left: 40px;
    }
    h3{
      margin-left: 40px;
    }
  }
}
</style>
